import {Component, Prop} from 'vue-property-decorator';
import * as tsx from 'vue-tsx-support';

import Options from '@/components/Selection/Options';

import OtherOptions from '@/components/Selection/OtherOptions';

import './style.less';

interface ISelection {
  data?: object;
  activeData?: object;
  changeSelection?: any
}

@Component
export default class Selection extends tsx.Component<ISelection> {
  
  @Prop() public data!: object
  @Prop() public activeData!: object
  @Prop() public changeSelection!: any
  
  render() {
    const {packageTopList = [], packageNormalList = []} = this.$props.data;
    if (packageNormalList.length === 0 && packageTopList.length === 0) {
      return (
        <div class='selection-container'>
          <img style="width: 45.71429vw; marginTop: 22.85714vw" src={require('../../assets/img/pack-list.png')} alt=""/>
        </div>
      )
    }
    return (
      <div class='selection-container'>
        {packageTopList.length !== 0 ?
          <div>
            <div class='name'>
              超级套餐
            </div>
            {packageTopList.map((item: object | undefined, index: string | number | undefined) =>  <Options changeSelection={this.$props.changeSelection} activeData={this.$props.activeData} key={index} data={item}/>)}
          </div> : null}
        {packageNormalList.length !== 0 ?
            <div>
              <div class='name'>其他套餐</div>
              {packageNormalList.map((item: object | undefined, index: string | number | undefined) =>  <OtherOptions changeSelection={this.$props.changeSelection} activeData={this.$props.activeData} key={index} data={item} />)}
            </div> : null
        }
        
      </div>
    )
  }
  
}